import { useRef, useEffect, useCallback, useId, SyntheticEvent } from 'react';
import { DialogTitle, Paper } from '@mui/material';
import type { DialogInstance } from './DialogInstance';

import styles from './NativeDialogWrapper.module.css';

export const NativeDialogWrapper = ({
  dialog,
  onSystemClose
}: {
  dialog: DialogInstance,
  onSystemClose: (dialog: DialogInstance, val: unknown) => void
}) => {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const titleId = useId();

  useEffect(() => {
    const el = dialogRef.current;
    if (el && !el.open) {
      el.showModal();
    }

    return () => {
      if (el && el.open) {
        el.close();
      }
    }
  }, []);

  const handleCancel = useCallback((e: SyntheticEvent<HTMLDialogElement>) => {
    e.preventDefault();
    onSystemClose(dialog, dialog.fallbackValue);
  }, [dialog, onSystemClose]);

  return (
    <dialog
      ref={dialogRef}
      onCancel={handleCancel}
      aria-label={dialog.ariaLabel}
      // aria-labelledby takes precedence over aria-label, so only use the title when no explicit label is given
      aria-labelledby={!dialog.ariaLabel && dialog.title ? titleId : undefined}
      className={styles['native-dialog-reset']}
    >
      {/* Same paper as MUI's Dialog. Content renders its own DialogContent/DialogActions, and DialogContent scrolls */}
      <Paper elevation={24} className={styles['dialog-paper']}>
        {dialog.title && <DialogTitle id={titleId}>{dialog.title}</DialogTitle>}
        {dialog.render()}
      </Paper>
    </dialog>
  );
}